import LogoSpinner from 'common/components/logoSpinner/LogoSpinner';
import { useStores } from 'common/hooks/useStores';
import useToast from 'common/hooks/useToast';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Auth from './Auth';

const K1Callback = () => {
    const navigate = useNavigate();
    const authStore = useStores().authStore;
    const { addToast } = useToast();

    async function callback() {
        const url = new URL(window.location.href);
        const state = url.searchParams.get('state');

        if (!state || state !== sessionStorage.getItem('k1State')) {
            console.error('Callback: invalid state');
            navigate('/login');
            return;
        }
        sessionStorage.removeItem('k1State');

        const auth = new Auth();
        const { route, token, ttl, ssoLogoutUrl, loginMessage } = await auth.handleAuthentication('k1');

        if (token && ttl) {
            authStore.setAuthToken(token);
            authStore.setAuthTTL(ttl);
            authStore.setSsoLogoutUrl(ssoLogoutUrl || null);
            Cookies.set('loginType', 'kaseya1', { expires: 1, domain: 'infocyte.com' });
        }

        if (loginMessage) {
            addToast({
                title: loginMessage.title,
                type: loginMessage.type,
                message: loginMessage.message,
                duration: loginMessage.type != 'error' ? 5000 : undefined
            });
        }

        navigate(route);
    }

    useEffect(() => {
        callback();
    }, []);

    return <LogoSpinner />;
};

export default observer(K1Callback);
